export function request(userId, bet) {
    return {
        type: 'BETSLIP_REMOVE_SPLIT_BET',
        userId,
        bet
    };
}
